/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './card_customization';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "bbfrontend": {
        "nested": {
          "common": {
            "nested": {
              "component": {
                "nested": {
                  "CardAccessoryDescription": {
                    "fields": {
                      "appearance": {
                        "type": ".squareup.bbfrontend.common.component.CardAccessoryDescription.Appearance",
                        "id": 3,
                        "rule": "optional",
                        "options": {
                          "default": "CARD_ACCESSORY_APPEARANCE_NORMAL"
                        }
                      },
                      "debit": {
                        "type": ".squareup.bbfrontend.common.component.CardAccessoryDescription.Debit",
                        "id": 1
                      },
                      "credit": {
                        "type": ".squareup.bbfrontend.common.component.CardAccessoryDescription.Credit",
                        "id": 2
                      }
                    },
                    "nested": {
                      "Appearance": {
                        "values": {
                          "CARD_ACCESSORY_APPEARANCE_NORMAL": 0,
                          "CARD_ACCESSORY_APPEARANCE_CLOSED": 1
                        }
                      },
                      "Debit": {
                        "fields": {
                          "bodyVariation": {
                            "type": ".squareup.bbfrontend.common.component.CardAccessoryDescription.Debit.DebitBodyVariation",
                            "id": 1,
                            "rule": "optional"
                          },
                          "businessName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "cardCustomization": {
                            "type": ".squareup.bbfrontend.common.component.CardCustomization",
                            "id": 3
                          },
                          "asyncCardCustomization": {
                            "type": ".squareup.bbfrontend.common.component.AsyncCardCustomization",
                            "id": 4
                          }
                        },
                        "nested": {
                          "DebitBodyVariation": {
                            "values": {
                              "DO_NOT_USE_BODY_VARIATION_DEBIT": 0,
                              "BODY_VARIATION_DEBIT_US": 1,
                              "BODY_VARIATION_DEBIT_CA": 2,
                              "BODY_VARIATION_DEBIT_UK": 3
                            }
                          },
                          "customization": {
                            "oneof": ["cardCustomization", "asyncCardCustomization"]
                          }
                        }
                      },
                      "Credit": {
                        "fields": {
                          "bodyVariation": {
                            "type": ".squareup.bbfrontend.common.component.CardAccessoryDescription.Credit.CreditBodyVariation",
                            "id": 1,
                            "rule": "optional"
                          }
                        },
                        "nested": {
                          "CreditBodyVariation": {
                            "values": {
                              "DO_NOT_USE_BODY_VARIATION_CREDIT": 0,
                              "BODY_VARIATION_CREDIT_US": 1
                            }
                          }
                        }
                      },
                      "product": {
                        "oneof": ["debit", "credit"]
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.CardAccessoryDescription && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.CardAccessoryDescription?.nested?.Appearance && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.CardAccessoryDescription?.nested?.Debit && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.CardAccessoryDescription?.nested?.Debit?.nested?.DebitBodyVariation && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.CardAccessoryDescription?.nested?.Credit && !$root.nested?.squareup?.nested?.bbfrontend?.nested?.common?.nested?.component?.nested?.CardAccessoryDescription?.nested?.Credit?.nested?.CreditBodyVariation) {
  $root.addJSON(jsonData);
}

/**
 * Configuration for a card accessory.
 * This accessory is meant to be a small representation of a card that cannot be interacted with.
 * The card accessory will be used mostly as a leading accessory in rows.
 * @see <a href="https://www.figma.com/design/3FzcTgyEm1okdw4MGZ0yfi/SPOS-Balance--%3E-Market?node-id=11967-28148&t=xIpx26tyLgu5b0n0-4">Figma assets</a>
 *
 * SOURCE CardAccessoryDescription @ squareup/bbfrontend/common/component/card_accessory.proto at 18:1
 */
export const CardAccessoryDescription = $root.lookupType('squareup.bbfrontend.common.component.CardAccessoryDescription');
fixType(CardAccessoryDescription);
Builder.createAndAttachToType(CardAccessoryDescription);
/**
 * Clients should apply additional styling based on the appearance property.
 * Note: Only use for styling decisions of the accessory.
 * This is not guaranteed to match the represented card state.
 *
 * SOURCE Appearance @ squareup/bbfrontend/common/component/card_accessory.proto at 32:3
 */
CardAccessoryDescription.Appearance = $root.lookupEnum('squareup.bbfrontend.common.component.CardAccessoryDescription.Appearance').values;
/**
 * SOURCE Debit @ squareup/bbfrontend/common/component/card_accessory.proto at 37:3
 */
CardAccessoryDescription.Debit = $root.lookupType('squareup.bbfrontend.common.component.CardAccessoryDescription.Debit');
fixType(CardAccessoryDescription.Debit, {
  bodyVariation: {
    required: true
  }
});
Builder.createAndAttachToType(CardAccessoryDescription.Debit);
/**
 * Currently the body variation corresponds to the merchant's country, but there could be different variations in the future.
 *
 * SOURCE DebitBodyVariation @ squareup/bbfrontend/common/component/card_accessory.proto at 52:5
 */
CardAccessoryDescription.Debit.DebitBodyVariation = $root.lookupEnum('squareup.bbfrontend.common.component.CardAccessoryDescription.Debit.DebitBodyVariation').values;
/**
 * SOURCE Credit @ squareup/bbfrontend/common/component/card_accessory.proto at 60:3
 */
CardAccessoryDescription.Credit = $root.lookupType('squareup.bbfrontend.common.component.CardAccessoryDescription.Credit');
fixType(CardAccessoryDescription.Credit, {
  bodyVariation: {
    required: true
  }
});
Builder.createAndAttachToType(CardAccessoryDescription.Credit);
/**
 * Currently the body variation corresponds to the merchant's country, but there could be different variations in the future.
 *
 * SOURCE CreditBodyVariation @ squareup/bbfrontend/common/component/card_accessory.proto at 65:5
 */
CardAccessoryDescription.Credit.CreditBodyVariation = $root.lookupEnum('squareup.bbfrontend.common.component.CardAccessoryDescription.Credit.CreditBodyVariation').values;